module.exports = __webpack_public_path__ + "img/title-HIWmg.6add08d6.png";